'use client'
import React, { PropsWithChildren, ReactNode, useId, useState} from 'react';

import styles from './show-more.module.css'
import clsx from 'clsx';

export type ShowMoreProps = {
  preview: string | ReactNode,
  content: string | ReactNode
  label?: string,
  className?: string
} & PropsWithChildren

export const ShowMore = ({preview, content, label, children}: ShowMoreProps)=> {
  const [open, setOpen] = useState(false)
  const id = useId()

  return (
    <>
      {preview}
      <div id={id} className={clsx(styles.content, open && styles['is-open'])}>{content}</div>
      <button className={styles.button} aria-controls={id} aria-expanded={open} onClick={() => setOpen(!open)}>{label ? label : 'Voir plus'}</button>
      {children}
    </>
  )
}